import { Transition, TransitionService } from '@uirouter/angularjs';
import { DashboardService } from './dashboard.service';

export function dashboardRun( $transitions: TransitionService,
                              dashboardService: DashboardService ) {
  $transitions.onSuccess({}, ( transition: Transition ) => {
    const isSbShow = transition.to().name.includes('small-business');
    dashboardService.toggleSbMenu(isSbShow);
  });
}

dashboardRun.$inject = [
  '$transitions',
  'DashboardService'
];



// WEBPACK FOOTER //
// ./app/states/dashboard/dashboard.run.ts